import _ from "lodash"
import { dataFix } from "../../common/dataFix"
import { createRefPath } from "../appData/appRefPaths"

export const mergePromise = (database_fns, refPath, vit, directCollection, sortedData) => {

  const coll = directCollection ? directCollection : vit

  const promises = []
  const _data = dataFix.cleanDocumentsData(sortedData)
  _.forEach(_data, (item, itemKey) => {
    const _refPath = createRefPath([coll, itemKey], refPath)
    if (database_fns) {
      delete _refPath.element
      const r = database_fns.doc_update(_refPath, item)
      promises.push(r)
    } else {
      console.log('no database_fns')
    }
  })
  return Promise.all(promises)
}